import AntdCascader from 'antd/lib/cascader'
import type { CascaderProps as AntdCascaderProps } from 'antd/lib/cascader'
import { connectReadonlyComponent } from '../connect'
import { PreviewText } from '../preview-text'

import 'antd/lib/cascader/style'

export * from 'antd/lib/cascader'

export type CascaderProps = AntdCascaderProps & {
  readonly?: boolean
}

// @ts-ignore
export const Cascader = connectReadonlyComponent(AntdCascader, PreviewText.Cascader)

export default Cascader
